export const TEN_ADDRESSES = {
  SESSION_KEY_CREATE: '0x0000000000000000000000000000000000000003',
  SESSION_KEY_RETRIEVE: '0x0000000000000000000000000000000000000007',
  SESSION_KEY_ACTIVATE: '0x0000000000000000000000000000000000000004',
  SESSION_KEY_DEACTIVATE: '0x0000000000000000000000000000000000000005',
  SESSION_KEY_DELETE: '0x0000000000000000000000000000000000000006',
  SESSION_KEY_EXECUTE: '0x0000000000000000000000000000000000000008'
} as const

export const TEN_CHAIN_ID = 443

export const DEFAULT_GAS_SETTINGS = {
  // Use percentiles for different network conditions
  PRIORITY_FEE_PERCENTILES: [25, 50, 75],
  // Number of blocks to look back for fee estimation
  FEE_HISTORY_BLOCKS: 10,
  // Base fee multipliers for different network conditions
  BASE_FEE_MULTIPLIERS: {
    LOW: 1.1,    // Low priority
    MEDIUM: 1.2, // Medium priority (default)
    HIGH: 1.5    // High priority
  }
} as const